import type { TimeOffDashboardSummary } from '../../../api/timeOff';
import { DashboardCardLinkButton } from './DashboardCardLinkButton';
import { displayEmployeeName, formatDashboardDateRange } from './dashboardCardFormatters';

interface TimeOffAttentionCardProps {
  summary: TimeOffDashboardSummary;
  manageHref: string;
}

export function TimeOffAttentionCard({ summary, manageHref }: TimeOffAttentionCardProps) {
  const totalAttention = summary.pendingCount + summary.needsIdentityCount + summary.dirtyLinks;

  return (
    <section className="dashboard-card dashboard-card--attention">
      <div className="dashboard-card__header">
        <div>
          <h3 className="dashboard-card__title">Time Off Health</h3>
          <p>Items HR may need to review</p>
        </div>
        <DashboardCardLinkButton text="Manage" href={manageHref} />
      </div>

      <div className="dashboard-attention-total">
        <span>{totalAttention}</span>
        <small>Total item(s)</small>
      </div>

      <div className="dashboard-attention-grid">
        <div>
          <strong>{summary.pendingCount}</strong>
          <span>Pending</span>
        </div>
        <div>
          <strong>{summary.needsIdentityCount}</strong>
          <span>Needs identity</span>
        </div>
        <div>
          <strong>{summary.dirtyLinks}</strong>
          <span>Queued sync</span>
        </div>
      </div>

      <div className="dashboard-card__section">
        <h4 className="dashboard-card__section-title">Items Needing Attention</h4>
        {summary.attentionItems.length === 0 ? (
          <p className="dashboard-empty">No items need attention right now.</p>
        ) : (
          <ul className="dashboard-upcoming-list">
            {summary.attentionItems.slice(0, 5).map((item) => (
              <li key={item.id}>
                <span>
                  <strong>{displayEmployeeName(item)}</strong>
                  <small>{item.type} · {item.reasons.join(' · ')} · {item.status}</small>
                </span>
                <span>{formatDashboardDateRange(item)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
